import * as React from "react";

export const Spinner = (props: { className?: string }) => (
	<div className={`spinner sk-folding-cube ${props.className || ""}`} role="status">
		<div className="sk-cube1 sk-cube"></div>
		<div className="sk-cube2 sk-cube"></div>
		<div className="sk-cube4 sk-cube"></div>
		<div className="sk-cube3 sk-cube"></div>
	</div>
);

export const SpinnerSmall = (props: { className?: string }) => (
	<div className={`spinner-border spinner-border-sm ${props.className || ""}`} role="status">
		<span className="sr-only">Loading...</span>
	</div>
);